// Angular modules
import { Component }            from '@angular/core';
import { EventEmitter }         from '@angular/core';
import { Input }                from '@angular/core';
import { OnInit }               from '@angular/core';
import { Output }               from '@angular/core';
import { AbstractControl }      from '@angular/forms';
import { FormControl }          from '@angular/forms';
import { FormGroup }            from '@angular/forms';

// Utils
import { DateIntervalUtil }     from './date-interval-field.util';

// Services
import { AuthService }          from '../../../../services/auth.service';

// Models
import { Filter }               from '../../../../models/page.model';
import { FilterDefaultOptions } from '../filter-default-options.model';

// Components
import { FilterComponent }      from '../filter.component';

@Component({
  selector    : 'app-date-interval-field',
  templateUrl : './date-interval-field.component.html',
  styleUrls   : ['./date-interval-field.component.scss']
})
export class DateIntervalFieldComponent implements OnInit, FilterComponent
{
  dateForm : FormGroup;
  hours    : Array<number> = [];
  minutes  : Array<number> = [];

  @Input() data: FilterDefaultOptions;

  @Output() dispatchFilterValue: EventEmitter<Filter> = new EventEmitter<Filter>();

  constructor() {}

  ngOnInit()
  {
    this.hours   = DateIntervalUtil.getArrayOfConsecutiveNumbers(0, 23);
    this.minutes = DateIntervalUtil.getArrayOfConsecutiveNumbers(0, 59);

    this.dateForm = new FormGroup({
      startDate    : new FormControl(null, []),
      startHours   : new FormControl(0, []),
      startMinutes : new FormControl(0, []),
      endDate      : new FormControl(null, []),
      endHours     : new FormControl(23, []),
      endMinutes   : new FormControl(59, [])
    });
  }

  resetStartDate(): void
  {
    this.startDate.reset();
    this.startHours.reset(0);
    this.startMinutes.reset(0);
  }

  resetEndDate(): void
  {
    this.endDate.reset();
    this.endHours.reset(23);
    this.endMinutes.reset(59);
  }

  get startDate(): AbstractControl
  {
    return this.dateForm.get('startDate');
  }

  get startHours(): AbstractControl
  {
    return this.dateForm.get('startHours');
  }

  get startMinutes(): AbstractControl
  {
    return this.dateForm.get('startMinutes');
  }

  get endDate(): AbstractControl
  {
    return this.dateForm.get('endDate');
  }

  get endHours(): AbstractControl
  {
    return this.dateForm.get('endHours');
  }

  get endMinutes(): AbstractControl
  {
    return this.dateForm.get('endMinutes');
  }

  onValidation(): void
  {
    const tz = JSON.parse(localStorage.getItem(AuthService.BusinessProfileKey)).timezone;

    const filterStart : Filter      = {};
    const filterEnd   : Filter      = {};
          filterStart.criteriaKey   = this.data.criteriaKey + 'Start';
          filterStart.criteriaLabel = this.data.criteriaLabel + '_START';
          filterEnd.criteriaKey     = this.data.criteriaKey + 'End';
          filterEnd.criteriaLabel   = this.data.criteriaLabel + '_END';

    if (this.startDate.value) {
      filterStart.value = DateIntervalUtil.getDateFilter(this.startDate.value, this.startHours.value, this.startMinutes.value, 0, tz).value;
      filterStart.dateLabel = DateIntervalUtil.getDateFilter(
        this.startDate.value,
        this.startHours.value,
        this.startMinutes.value,
        0,
        tz
      ).dateLabel;
      this.dispatchFilterValue.emit(filterStart);
    }

    if (this.endDate.value) {
      filterEnd.value = DateIntervalUtil.getDateFilter(this.endDate.value, this.endHours.value, this.endMinutes.value, 59, tz).value;
      filterEnd.dateLabel = DateIntervalUtil.getDateFilter(
        this.endDate.value,
        this.endHours.value,
        this.endMinutes.value,
        59,
        tz
      ).dateLabel;
      this.dispatchFilterValue.emit(filterEnd);
    }

    this.resetStartDate();
    this.resetEndDate();
  }
}
